<script setup>
import { useAuth0 } from '@auth0/auth0-vue'
import { computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import LoadingView from './views/LoadingView.vue'

const { isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0()
const route = useRoute()

// The login route deep-links back into the app and must render without auth.
// Check window.location too: on initial load the router's first navigation is
// async, so route.name may still be undefined when this first evaluates.
const isLoginRoute = computed(
  () => route.name === 'login' || window.location.pathname.replace(/\/$/, '').endsWith('/login')
)

// Redirect to Auth0 if not authenticated
watchEffect(() => {
  if (!isLoginRoute.value && !isLoading.value && !isAuthenticated.value) {
    loginWithRedirect()
  }
})

const handleLogout = () => {
  logout({
    logoutParams: {
      returnTo: window.location.origin
    }
  })
}
</script>

<template>
  <button v-if="isAuthenticated" @click="handleLogout" class="logout-btn">Sign Out</button>

  <main>
    <div class="card">
      <LoadingView v-if="!isLoginRoute && (isLoading || !isAuthenticated)" />
      <router-view v-else />
    </div>
  </main>
</template>

<style>
body {
  background-image: url('@/assets/logo_top_left.svg');
  background-repeat: no-repeat !important;
  background-position: center;
  background-size: cover !important;
  min-height: 100vh;
  background-attachment: fixed;
}
</style>

<style scoped>
main {
  display: flex;
  justify-content: center;
  padding: 4rem 2rem 2rem 2rem;
}

.card {
  background: var(--color-background);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 100%;
  height: fit-content;
}

@media (max-width: 450px) {
  main {
    padding: 2rem 0.5rem 1rem 0.5rem;
  }

  .card {
    border-radius: 8px;
  }
}


.logout-btn {
  position: fixed;
  top: 1rem;
  right: 1rem;
  background: transparent;
  color: var(--color-primary);
  border: none;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  z-index: 1000;
}

@media (max-width: 450px) {
  .logout-btn {
    top: 0.5rem;
    right: 0.5rem;
    padding: 0.4rem 0.75rem;
    font-size: 0.9rem;
  }
}
</style>
